import {useLocaleStore} from '../../stores/localeStore';
import {debug} from '../../shared/helpers/debug';

/**
 *
 * @param {RouteLocationNormalized} to
 * @return {NavigationGuardResult}
 */
export function adjustUrlLocale(to) {
    if (__IS_HYBRID_APP__) {
        return;
    }
    const {currentLocale, updateLocale, availableLanguages} = useLocaleStore();
    //adjust locale in url if changed
    const [, lang] = to.href.split('/');

    if (lang !== currentLocale) {
        debug.log('locale adjustment');
        window.location.href = `${window.location.origin}/${currentLocale}${to.fullPath}`;

        return new Promise(() => {});
    }

    // adjust locale in url (from initial url)
    const localeString = availableLanguages.join('|');
    // the locale must be a whole segment, or "/delete-bookings" would read as locale "de"
    const pattern = new RegExp(`^/(${localeString})([/?#].*)?$`);
    const parts = pattern.exec(to.fullPath);
    if (!parts) {
        return;
    }

    const locale = parts[1] || null;

    if (!availableLanguages.includes(locale)) {
        return;
    }

    debug.log('locale adjustment');

    updateLocale(locale);
    window.location.href = to.fullPath;

    return new Promise(() => {});
}
